import { gql } from '@apollo/client';

export const GET_INVESTMENT_DATA = gql`
  query getInvestmentData($id: Int!) {
    getPublicationInvestmentView(publication_id: $id)
  }
`;
